<dx-popup
  id="dialog-sortie-lot"
  [(visible)]="displayDialog"
  [height]="'auto'"
  [width]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="false">
  <div *dxTemplate="let _ of 'title'" class="sortie-lot-header">
    <div class="lot-dialog-title">
      <yo-icon icon="sign-out-alt"></yo-icon>
      Sortir le lot <strong>{{ selectedStock?.lotArticle }}</strong> - ({{ selectedStock?.article }})
    </div>

    <div class="sortie-lot-actions">
      <yo-button iconClass="fas fa-sign-out-alt"
                 (onClick)="sortirLot()"
                 [theme]="ButtonThemeEnum.ADD"
                 tooltip="Sortir un lot du stock">
      </yo-button>
      <yo-button iconClass="fas fa-times"
                 [theme]="ButtonThemeEnum.CANCEL"
                 (onClick)="closeDialog()"
                 tooltip="Annuler">
      </yo-button>
    </div>
  </div>

  @if (!utils.isNullOrEmpty(selectedStock)) {
    <section class="sortie-lot-content">
      <div class="sortie-lot-column">

        <span class="sortie-lot-section-title">
          <strong>Informations générales</strong>
        </span>

        <div class="sortie-lot-list">
          <div class="sortie-lot-row">
            <span>Unité de production</span>
            <span class="sortie-lot-value">
            <i class="fas fa-industry"></i>
              {{ selectedStock.udpLibelle }}
          </span>
          </div>

          <div class="sortie-lot-row">
            <span>Zone de stockage</span>
            <span class="sortie-lot-value">
            <i class="fas fa-cubes"></i>
              {{ selectedStock.zdsLibelle }}
          </span>
          </div>

          <div class="sortie-lot-row">
            <span>Réf. interne</span>
            <span class="sortie-lot-value">
            {{ selectedStock.referenceInterne }}
          </span>
          </div>

          <div class="sortie-lot-row">
            <span>Dénomination</span>
            <span class="sortie-lot-value">
            {{ selectedStock.article }}
          </span>
          </div>

          <div class="sortie-lot-row">
            <span>Lot</span>
            <span class="sortie-lot-value">
            {{ selectedStock.lotArticle }}
          </span>
          </div>

          <div class="sortie-lot-row">
            <span>Lot fournisseur</span>
            <span class="sortie-lot-value">
            {{ selectedStock.lotArticleFournisseur }}
          </span>
          </div>

          <div class="sortie-lot-row">
            <span>Date d'entrée</span>
            <span class="sortie-lot-value">
            {{ selectedStock.dateEntree | date:'dd/MM/yyyy' }}
          </span>
          </div>

          <div class="sortie-lot-row">
            <span>DLC / DDM</span>
            <span class="sortie-lot-value"
                  [class.isPerime]="stockSvc.isPerime(selectedStock.dlc, filters)">
            {{ selectedStock.dlc | date:'dd/MM/yyyy' }}
          </span>
          </div>

          <div class="sortie-lot-row">
            <span title="En unité de stockage">
              Quantité actuelle
            </span>
            <span class="sortie-lot-value sortie-lot-value highlight">
              {{ selectedStock.quantite }} {{ selectedStock.uniteStockageAbreviation }}
            </span>
          </div>

          <div class="sortie-lot-row">
            <span title="En unité de facturation">Prix</span>
            <span class="sortie-lot-value">
              {{ selectedStock.prixUnitaire
              | currency:'EUR':'symbol':'1.4-4' }}
              / {{ selectedStock.uniteFacturationAbreviation }}
            </span>
          </div>

        </div>
      </div>

      <div class="sortie-lot-column">

        <span class="sortie-lot-section-title">
            <strong>Détails de la sortie</strong>
        </span>

        <form [formGroup]="form" class="sortie-lot-list">
          <div class="sortie-lot-row">
            <span>Quantité à sortir</span>
            <div  class="sortie-lot-value">
              <div class="sortie-lot-text-box">
                <!-- min 0 -->
                <yo-text-box
                  [value]="'' + form.controls['quantite'].value"
                  (onValueChanged)="form.controls['quantite'].setValue(+$event)"
                  (keydown)="utils.keydownNumber($event,form,'quantite',true)">
                </yo-text-box>
                <strong> {{selectedStock.uniteStockageAbreviation}}</strong>
              </div>
              <ng-container
                *ngTemplateOutlet="tplError;context:{form:form,property:'quantite',label:'Quantité à sortir'}">
              </ng-container>
            </div>
          </div>

          <div class="sortie-lot-row">
            <span>Date de sortie</span>
            <div class="sortie-lot-value">
              <dx-date-box
                type="date"
                displayFormat="dd/MM/yyyy"
                formControlName="dateSortie"
                [calendarOptions]="{
                  firstDayOfWeek: 1,
                  showWeekNumbers: true
                }">
              </dx-date-box>
              <ng-container
                *ngTemplateOutlet="tplError;context:{form:form,property:'dateSortie',label:'Date de la sortie'}"></ng-container>
            </div>
          </div>

          <div class="sortie-lot-row" id="yo-dx-list">
            <span>Motif de la sortie</span>
            <div class="sortie-lot-value">
              <dx-list
                [dataSource]="mouvementStatutList"
                displayExpr="libelle"
                keyExpr="id"
                selectionMode="single"
                (onSelectionChanged)="onMotifSelectionChanged($event)">
              </dx-list>
              <ng-container
                *ngTemplateOutlet="tplError;context:{form:form,property:'motif',label:'Motif de la sortie'}"></ng-container>
            </div>
          </div>

          <div class="sortie-lot-row" id="yo-text-area">
            <span>Remarque</span>
            <div class="sortie-lot-value">
              <textarea formControlName="remarque"></textarea>
              <ng-container
                *ngTemplateOutlet="tplError;context:{form:form,property:'remarque',label:'Remarque'}"></ng-container>
            </div>
          </div>
        </form>
      </div>
    </section>
  }

</dx-popup>


<ng-template #tplError let-form="form" let-property="property" let-label="label">
  @if (form.controls[property].invalid && (form.controls[property].dirty || form.controls[property].touched)) {
    <div class="error">

      <pre>{{form.controls[property].validators | json}}</pre>

      @if (form.controls[property].hasError('required')) {
        <div class="pg-2">
          {{startError(label)}} est obligatoire.
        </div>
      }
      @if (form.controls[property].hasError('minlength')) {
        <div class="pg-2">
          {{startError(label)}} ne peut avoir moins de {{form.controls[property].errors?.['minlength']}} caractères.
        </div>
      }
      @if (form.controls[property].hasError('maxlength')) {
        <div class="pg-2">
          {{startError(label)}} ne peut dépasser {{form.controls[property].errors?.['maxlength']}} caractères.
        </div>
      }
      @if (form.controls[property].hasError('min')) {
        <div class="pg-2">
          {{startError(label)}} doit être supérieur ou égal à {{form.controls[property].errors?.['min']?.['min']}}.
        </div>
      }
      @if (form.controls[property].hasError('max')) {
        <div class="pg-2">
          {{startError(label)}} doit être inférieur ou égal à {{form.controls[property].errors?.['max']?.['max']}}.
        </div>
      }

    </div>
  }

</ng-template>

